"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Facebook, Instagram, Twitter, Pin, MapPin, Mail, MessageCircle, ArrowUp } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-border/20 animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Pin,
    href: "#",
    label: "Pinterest"
  }];
  return <section data-section-id="236359" id="footer" className="dark bg-background pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/alpine_engineering_logo_white.png" alt="Alpine Engineering Logo" className="h-7 w-auto object-contain" />
            </Link>
            <div className="space-y-2">
              <p className="text-muted-foreground text-sm leading-relaxed font-mono">
                Alpine Engineering, LLC. Professional structural and civil engineering services across the Western United States.
              </p>
              <p className="text-xs text-muted-foreground/60 font-mono">CA PE #C91243 | UT SE #189357-2203</p>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-tight uppercase">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-tight uppercase">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-mono">
                <MapPin className="size-5 text-ring shrink-0 mt-0.5" />
                <span>Alpine Engineering HQ<br />1408 W Galvez Drive, Los Angeles, CA&nbsp;United States</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-mono">
                <Mail className="size-5 text-ring shrink-0" />
                <Link to="mailto:contact@alpine-eng.com" className="hover:text-primary transition-colors">
                  contact@alpine-eng.com
                </Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground font-mono">
                <MessageCircle className="size-5 text-ring shrink-0" />
                <Link to="/ConsultationPage" className="hover:text-primary transition-colors font-medium">
                  Schedule Consultation
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-tight uppercase">
              Follow Us
            </h3>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} newTab aria-label={social.label} className="size-10 rounded-none bg-secondary text-secondary-foreground flex items-center justify-center hover:bg-ring hover:text-white transition-colors border border-border">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground text-center sm:text-left font-mono uppercase tracking-widest">
            © {new Date().getFullYear()} Alpine Engineering, LLC. All rights reserved.
          </p>
          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-none bg-background hover:bg-ring hover:text-white border-border shadow-none transition-all" aria-label="Back to top">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </section>;
}